import React from 'react';
import { useNavigate } from 'react-router-dom';

const RH = () => {
  const navigate = useNavigate();

  const handleNavigate = (path) => {
    navigate(path);
  };

  const modules = [
    {
      title: 'Colaboradores',
      description: 'Gestão de funcionários',
      path: '/rh/colaboradores',
      icon: '👥',
      bgColor: 'var(--color-primary-medium)',
      hoverColor: 'var(--color-primary-light)',
      borderColor: 'var(--color-primary-medium)'
    },
    {
      title: 'Atestados',
      description: 'Homologação de atestados',
      path: '/rh/atestados',
      icon: '📄',
      bgColor: 'var(--color-primary-light)',
      hoverColor: 'var(--color-accent)',
      borderColor: 'var(--color-primary-light)'
    },
    {
      title: 'Férias',
      description: 'Controle de férias',
      path: '/rh/ferias',
      icon: '🏖️',
      bgColor: 'var(--color-primary-medium)',
      hoverColor: 'var(--color-primary-light)',
      borderColor: 'var(--color-primary-medium)'
    },
    {
      title: 'Benefícios',
      description: 'Gestão de benefícios',
      path: '/rh/beneficios',
      icon: '🎁',
      bgColor: 'var(--color-primary-light)',
      hoverColor: 'var(--color-accent)',
      borderColor: 'var(--color-primary-light)'
    },
    {
      title: 'Gestão RH',
      description: 'Processos e gestão',
      path: '/rh/gestao',
      icon: '📊',
      bgColor: 'var(--color-accent)',
      hoverColor: 'var(--color-primary-medium)',
      borderColor: 'var(--color-accent)'
    }
  ];

  return (
    <div className="p-6 min-h-screen bg-neutral-light animate-fade-in-up">
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-4xl font-bold mb-2 text-primary-dark">
          Recursos Humanos 🏢
        </h1>
        <p className="text-neutral-dark text-lg">
          Gerencie todos os aspectos relacionados aos colaboradores
        </p>
        <div className="w-20 h-1 gradient-primary rounded-full mt-3"></div>
      </div>

      {/* Grid de Módulos */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6">
        {modules.map((module, index) => (
          <div
            key={module.path}
            className="bg-white p-6 rounded-xl shadow-lg card-primary hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 group cursor-pointer"
            style={{ 
              borderLeftColor: module.borderColor,
              animationDelay: `${index * 100}ms`
            }}
            onClick={() => handleNavigate(module.path)}
          >
            {/* Icon */}
            <div 
              className="w-12 h-12 rounded-lg flex items-center justify-center mb-4 text-2xl transition-all duration-300 group-hover:scale-110"
              style={{ backgroundColor: `${module.bgColor}20` }}
            >
              {module.icon}
            </div>

            {/* Content */}
            <h3 className="text-xl font-semibold mb-2 text-primary-dark group-hover:text-primary-medium transition-colors">
              {module.title}
            </h3>
            <p className="text-neutral-dark mb-4 text-sm leading-relaxed">
              {module.description}
            </p>

            {/* Button */}
            <button 
              className="w-full py-2 px-4 rounded-lg font-medium transition-all duration-300 text-white transform group-hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2"
              style={{ 
                backgroundColor: module.bgColor,
                boxShadow: `0 2px 8px ${module.bgColor}30`
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = module.hoverColor;
                e.target.style.transform = 'scale(1.05)';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = module.bgColor;
                e.target.style.transform = 'scale(1)';
              }}
              onFocus={(e) => {
                e.target.style.ringColor = module.bgColor;
              }}
            >
              <span className="flex items-center justify-center">
                Acessar
                <span className="ml-2 transform group-hover:translate-x-1 transition-transform">→</span>
              </span>
            </button>
          </div>
        ))}
      </div>

      {/* Statistics Cards */}
      <div className="mt-12 grid grid-cols-1 md:grid-cols-4 gap-6">
        <div className="bg-white p-6 rounded-xl card-accent">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-neutral-dark font-medium">Total Colaboradores</p>
              <p className="text-2xl font-bold text-primary-dark">150</p>
            </div>
            <div className="w-12 h-12 bg-accent rounded-lg flex items-center justify-center">
              <span className="text-2xl">👥</span>
            </div>
          </div>
        </div>

        <div className="bg-white p-6 rounded-xl card-primary">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-neutral-dark font-medium">Atestados Pendentes</p>
              <p className="text-2xl font-bold text-primary-dark">8</p>
            </div>
            <div className="w-12 h-12 bg-primary-medium rounded-lg flex items-center justify-center">
              <span className="text-2xl text-white">📄</span>
            </div>
          </div>
        </div>

        <div className="bg-white p-6 rounded-xl card-secondary">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-neutral-dark font-medium">Férias Aprovadas</p>
              <p className="text-2xl font-bold text-primary-dark">12</p>
            </div>
            <div className="w-12 h-12 bg-primary-light rounded-lg flex items-center justify-center">
              <span className="text-2xl">🏖️</span>
            </div>
          </div>
        </div>

        <div className="bg-white p-6 rounded-xl card-accent">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-neutral-dark font-medium">Processos Ativos</p>
              <p className="text-2xl font-bold text-primary-dark">5</p>
            </div>
            <div className="w-12 h-12 bg-accent rounded-lg flex items-center justify-center">
              <span className="text-2xl">📊</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RH;